/* Cœura cart drawer — opens on add-to-cart and from the header Cart link, renders the whole cart
   (proof image, personalization, quantity + remove, subtotal, checkout), and on a personalized add
   hosts the upsell (CoeuraUpsell.render). Live updates via /cart/change.js; re-reads /cart.js after
   each change. The /cart page remains the no-JS fallback. */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var bodyEl = drawer.querySelector('[data-cd-body]');
  var footEl = drawer.querySelector('[data-cd-foot]');
  var subEl = drawer.querySelector('[data-cd-subtotal]');
  var titleEl = drawer.querySelector('[data-cd-title]');
  var fmt = drawer.getAttribute('data-money-format') || '${{amount}}';
  var cartUrl = drawer.getAttribute('data-cart-url') || '/cart';

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function money(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function wd(n, p, th, dec) {
      p = p == null ? 2 : p; th = th == null ? ',' : th; dec = dec == null ? '.' : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(p);
      var parts = n.split('.'), d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th), c = parts[1] ? dec + parts[1] : '';
      return d + c;
    }
    var m = fmt.match(re), tok = m ? m[1] : 'amount', v;
    switch (tok) {
      case 'amount_no_decimals': v = wd(cents, 0); break;
      case 'amount_with_comma_separator': v = wd(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = wd(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = wd(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': v = wd(cents, 0, ' ', ''); break;
      default: v = wd(cents, 2);
    }
    return fmt.replace(re, v);
  }
  function bumpHeader(n) {
    var a = document.getElementById('cart-n'); if (a) a.textContent = n;
    document.querySelectorAll('.cart-n-m').forEach(function (e) { e.textContent = n; });
  }

  /* Build the "edit this line" URL: the product page, with its variant + composed state pre-filled
     from the line's _Engraving spec (falling back to visible properties) and an ?edit=<key> flag so
     the PDP replaces this exact line on re-add instead of adding a duplicate. */
  var FONTKEY = { 'Script': 'script', 'Small caps': 'caps', 'Caps': 'caps', 'Serif': 'serif', 'Pitch': 'pitch' };
  function editUrl(item) {
    var base = (item.url || '').split('?')[0], q = [], props = item.properties || {};
    if (item.variant_id) q.push('variant=' + item.variant_id);
    var eng = null; try { eng = JSON.parse(props._Engraving || 'null'); } catch (e) {}
    var pl = eng && eng.placements && eng.placements[0];
    if (pl) {
      if (pl.mode === 'initials' && pl.letters) q.push('letters=' + encodeURIComponent(pl.letters));
      else if (pl.mode === 'date' && pl.night) q.push('night=' + encodeURIComponent(pl.night));
      else if (pl.mode === 'engraving' && pl.lines) {
        q.push('lines=' + encodeURIComponent(JSON.stringify(pl.lines.map(function (l) { return l.text; }))));
        var f = pl.lines[0] && pl.lines[0].font; if (f && FONTKEY[f]) q.push('font=' + FONTKEY[f]);
      }
      if (pl.id && pl.id !== 'main') q.push('place=' + encodeURIComponent(pl.id));
    } else {
      if (props.Letters) q.push('letters=' + encodeURIComponent(props.Letters));
      if (props.Night) q.push('night=' + encodeURIComponent(props.Night));
    }
    q.push('edit=' + encodeURIComponent(item.key));
    return base + (q.length ? '?' + q.join('&') : '');
  }
  window.CoeuraCart = { editUrl: editUrl };

  /* a carrier the "Complete necklace" discount has brought to $0 reads as a gift — "— on us", its full
     price struck beside it — never a bare $0.00 */
  function onUs(it) { return it.product_type === 'Carrier' && it.final_line_price === 0 && it.original_line_price > 0; }

  function lineEl(it) {
    var props = it.properties || {}, proof = props._Proof, personalized = !!(props._Engraving || proof);
    var gift = onUs(it);
    var wrap = document.createElement('div');
    wrap.className = 'cd-line' + (personalized ? ' is-personalized' : '');
    wrap.setAttribute('data-key', it.key);
    var img = proof ? esc(proof) : (it.image ? esc(it.image) : '');
    var media = '<a class="cd-line__media" href="' + esc(it.url) + '">' + (img ? '<img src="' + img + '" alt="">' : '') +
      (personalized ? '<span class="cd-line__tag">Personalized</span>' : '') + '</a>';
    var propsHtml = '';
    if (personalized) {
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) !== '_' && props[k]) propsHtml += '<div class="cd-line__p"><span class="cd-line__k mono">' + esc(k) + '</span><span>' + esc(props[k]) + '</span></div>';
      });
    }
    var variant = (it.variant_title && it.variant_title.indexOf('Default') < 0) ? '<div class="cd-line__variant mono">' + esc(it.variant_title) + '</div>' : '';
    wrap.innerHTML = media +
      '<div class="cd-line__body">' +
        '<a class="cd-line__name" href="' + esc(it.url) + '">' + esc(it.product_title || it.title) + (gift ? ' — on us' : '') + '</a>' + variant +
        (propsHtml ? '<div class="cd-line__props">' + propsHtml + '</div>' : '') +
        '<div class="cd-line__ctrls">' +
          '<div class="cart-qty"><button type="button" class="cart-qty__btn" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<input class="cart-qty__in mono" data-qty-in type="text" inputmode="numeric" pattern="[0-9]*" value="' + it.quantity + '" aria-label="Quantity">' +
          '<button type="button" class="cart-qty__btn" data-step="1" aria-label="Increase quantity">+</button></div>' +
          (personalized ? '<a class="cd-line__edit mono" href="' + esc(editUrl(it)) + '">Edit</a>' : '') +
          '<button type="button" class="cd-line__remove mono" data-remove>Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="cd-line__price mono" data-line-price>' + (gift ? '<s style="color:var(--gray-deep)">' + money(it.original_line_price) + '</s>' : money(it.final_line_price)) + '</div>';
    return wrap;
  }

  function render() {
    bodyEl.setAttribute('aria-busy', 'true');
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      bumpHeader(cart.item_count);
      bodyEl.innerHTML = '';
      bodyEl.removeAttribute('aria-busy');
      if (!cart.item_count) {
        bodyEl.innerHTML = '<div class="cd-empty"><p class="body-copy" style="font-style:italic;color:var(--gray)">Your cart is empty.</p>' +
          '<p style="margin-top:16px"><a class="btn" href="/collections/all-pieces">Enter the shop</a></p></div>';
        footEl.hidden = true;
        return cart;
      }
      cart.items.forEach(function (it) { bodyEl.appendChild(lineEl(it)); });
      if (drawer._upsell && window.CoeuraUpsell && window.CoeuraUpsell.render) {
        var us = document.createElement('div'); us.className = 'cd-upsell';
        try { if (window.CoeuraUpsell.render(us, drawer._upsell)) bodyEl.appendChild(us); } catch (e) {}
      }
      subEl.textContent = money(cart.total_price);
      footEl.hidden = false;
      return cart;
    }).catch(function () {
      bodyEl.removeAttribute('aria-busy');
      bodyEl.innerHTML = '<p class="cd-loading mono">Cart unavailable. <a href="' + cartUrl + '">Open the cart page</a>.</p>';
    });
  }

  function change(key, q) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: q })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }
  function commit(line, q) {
    line.classList.add('is-busy');
    change(line.getAttribute('data-key'), q).then(function () { render(); }).catch(function () { line.classList.remove('is-busy'); });
  }

  bodyEl.addEventListener('click', function (e) {
    var line = e.target.closest('.cd-line'); if (!line) return;
    var step = e.target.closest('[data-step]');
    if (step) {
      var inp = line.querySelector('[data-qty-in]');
      // minus at one takes the piece out of the cart, which is what the button looks like it should do
      var q = Math.max(0, (parseInt(inp.value, 10) || 1) + parseInt(step.getAttribute('data-step'), 10));
      commit(line, q);
      return;
    }
    if (e.target.closest('[data-remove]')) commit(line, 0);
  });
  bodyEl.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-qty-in]'); if (!inp) return;
    var q = parseInt(inp.value, 10); if (isNaN(q) || q < 1) q = 1;
    commit(inp.closest('.cd-line'), q);
  });

  var lastFocus = null;
  function open(opts) {
    opts = opts || {};
    drawer._upsell = opts.upsell || null;
    titleEl.textContent = opts.title || (opts.upsell ? 'Added to your cart' : 'Your cart');
    lastFocus = document.activeElement;
    document.documentElement.classList.add('cd-open');
    if (overlay) overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    render();
    var cl = drawer.querySelector('[data-cd-close]'); if (cl) cl.focus();
  }
  function close() {
    document.documentElement.classList.remove('cd-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  drawer.querySelector('[data-cd-close]').addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  // header Cart links open the drawer (links inside the drawer keep their normal behavior)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]'); if (!a || a.closest('[data-cart-drawer]')) return;
    var href = a.getAttribute('href') || '';
    if (a.classList.contains('u-cart') || href === cartUrl || href === '/cart' || href === '/cart/') {
      e.preventDefault(); open({});
    }
  });

  window.CoeuraCartDrawer = { open: open, close: close, refresh: render };

  // upgrade server-rendered cart-page Edit links (they ship with a plain product href fallback) to the
  // full pre-filled edit URL now that the builder is available.
  document.querySelectorAll('a[data-edit]').forEach(function (a) {
    try {
      a.href = editUrl({ url: a.getAttribute('data-url'), key: a.getAttribute('data-key'), variant_id: a.getAttribute('data-vid'), properties: { _Engraving: a.getAttribute('data-eng') || '' } });
    } catch (e) {}
  });
})();
